import PATHS, { FLOWGO_PATH } from './constants/paths';

export default Object.keys(PATHS).reduce(
  (acc, k) => ({ ...acc, [k]: `${FLOWGO_PATH}/${PATHS[k]}` }),
  {} as typeof PATHS
);
